// Phase B Lite — Canonical RSVP label resolver.
//
// Reads a raw `labels` object (any shape, including legacy aliases authored
// in earlier phases) and returns a canonical-keyed object. When both a
// canonical and a legacy key exist, the canonical wins. Pure function —
// no side effects, no defaults applied (variants keep their own inline
// fallback copy so each layout can still feel distinct).
//
// Canonical keys (read by all 6 RSVP variants going forward):
//   Shared:    heading, subheading, nameLabel, namePlaceholder, attendLabel,
//              yesLabel, noLabel, submitLabel, guestCountLabel, dietaryLabel,
//              dietaryPlaceholder, songLabel, songPlaceholder, messageLabel,
//              messagePlaceholder, phoneLabel, phonePlaceholder, emailLabel,
//              emailPlaceholder, thankYouTitle, thankYouAccept, thankYouDecline.
//   Immersive: transitionTitle, transitionSubtitle, guestsTitle,
//              guestsSubtitle, musicTitle, musicHint, declineNoteTitle,
//              declineNotePlaceholder.
//   Detailed:  childrenLabel, childrenQuestion, childrenYes, childrenNo,
//              childrenCountLabel.

export function resolveRsvpLabels(raw) {
  const L = raw || {};
  return {
    // ─── Shared across all 6 variants ────────────────────────────
    heading:            L.heading            ?? L.introText,
    subheading:         L.subheading         ?? L.subtitle,
    nameLabel:          L.nameLabel,
    namePlaceholder:    L.namePlaceholder,
    attendLabel:        L.attendLabel,
    yesLabel:           L.yesLabel           ?? L.yesText,
    noLabel:            L.noLabel            ?? L.noText,
    submitLabel:        L.submitLabel        ?? L.submitText        ?? L.confirmLabel,
    guestCountLabel:    L.guestCountLabel,
    dietaryLabel:       L.dietaryLabel       ?? L.menuLabel,
    dietaryPlaceholder: L.dietaryPlaceholder ?? L.allergiesPlaceholder,
    songLabel:          L.songLabel          ?? L.musicSubtitle,
    songPlaceholder:    L.songPlaceholder,
    messageLabel:       L.messageLabel       ?? L.messageTitle,
    messagePlaceholder: L.messagePlaceholder,
    phoneLabel:         L.phoneLabel,
    phonePlaceholder:   L.phonePlaceholder,
    emailLabel:         L.emailLabel,
    emailPlaceholder:   L.emailPlaceholder,
    thankYouTitle:      L.thankYouTitle      ?? L.confirmationTitle,
    thankYouAccept:     L.thankYouAccept     ?? L.confirmationSubtitle,
    thankYouDecline:    L.thankYouDecline    ?? L.declineTitle,

    // ─── Immersive multi-step extras ─────────────────────────────
    transitionTitle:        L.transitionTitle,
    transitionSubtitle:     L.transitionSubtitle,
    guestsTitle:            L.guestsTitle,
    guestsSubtitle:         L.guestsSubtitle,
    musicTitle:             L.musicTitle,
    musicHint:              L.musicHint,
    declineNoteTitle:       L.declineNoteTitle,
    declineNotePlaceholder: L.declineNotePlaceholder,
    declineSubtitle:        L.declineSubtitle ?? L.thankYouDecline,

    // ─── Detailed-only extras ────────────────────────────────────
    childrenLabel:      L.childrenLabel,
    childrenQuestion:   L.childrenQuestion,
    childrenYes:        L.childrenYes,
    childrenNo:         L.childrenNo,
    childrenCountLabel: L.childrenCountLabel,
  };
}
